import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ToastContainer, ToastWrapper, ToastMessage } from './components/ToastStyles';
import IconButton from '../../atoms/IconButton';

// A simple global state/DOM node for the portal could be managed here,
// but usually it's better if the consumer places ToastContainer near the root.
// For the sake of "React Portal nativo", we'll create a div on body if not exists.
let portalRoot = null;
if (typeof document !== 'undefined') {
  portalRoot = document.getElementById('toast-root');
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.setAttribute('id', 'toast-root');
    document.body.appendChild(portalRoot);
  }
}

const Toast = ({ position, toasts, removeToast }) => {
  if (!portalRoot) return null;

  return ReactDOM.createPortal(
    <ToastContainer position={position}>
      {toasts.map((toast) => (
        <ToastWrapper key={toast.id} type={toast.type}>
          <ToastMessage>{toast.message}</ToastMessage>
          <IconButton
            icon="times"
            color="inherit"
            ariaLabel="Close Toast"
            onClick={() => removeToast(toast.id)}
          />
        </ToastWrapper>
      ))}
    </ToastContainer>,
    portalRoot
  );
};

Toast.propTypes = {
  position: PropTypes.oneOf([
    'top-right',
    'top-left',
    'bottom-right',
    'bottom-left',
    'top-center',
    'bottom-center',
  ]),
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['success', 'danger', 'error', 'warning', 'info']),
    })
  ).isRequired,
  removeToast: PropTypes.func.isRequired,
};

Toast.defaultProps = {
  position: 'top-right',
};

export default Toast;



// WEBPACK FOOTER //
// ./src/design-system/molecules/Toast/Toast.jsx